import BaseComponent from '../../../js/base-component';

class ListTeaser extends BaseComponent {
    constructor(options) {

        super(options);

        let skip = 6,
            step = 6; //estimate the news to be skipped when loading

        const newsApiUrl = '/api/news/get/more?skip=',

            init = function () {
                document.querySelector(".u-list-teaser__more").addEventListener('click', loadMore);
            },

            /**
             * load more news and append on the existing list
             */
            loadMore = function () {

                fetch(newsApiUrl + skip)
                    .then(function (response) {
                        skip += step;
                        return response.text()
                    }).then(function (html) {
                    if (html && html.length) {
                        render(html);
                    } else {
                        removeLoadMoreBtn();
                    }
                }).catch(function (err) {
                    // There was an error
                    console.warn('Something went wrong.', err);
                });
            },

            /**
             *  append to the existing news
             * @param content
             */
            render = function (content) {
                const newsWrapper = document.querySelector('.u-list-teaser__wrapper');
                newsWrapper.innerHTML = newsWrapper.innerHTML + content;
            },

            /**
             * remove the loadmore button
             */
            removeLoadMoreBtn = function () {
                let loadMoreBtn = document.querySelector(".u-list-teaser__more");
                loadMoreBtn.parentNode.removeChild(loadMoreBtn);
            }

        init();
    }
}

export default {
    name: "ListTeaser",
    definition: ListTeaser,
};
